import { EVALUATE_HEALTH_TESTS, COMPANIES_TESTS, ONLY_360_USERS_TESTS, NOT_IN_MX_TESTS, INDEPENDENT_TESTS } from "@/constants/patientServices"
import { inMx } from '@/helpers/global.helpers'

export function testToShow (companyServices, professionalOrCenter = false) {
    var totalTests = EVALUATE_HEALTH_TESTS
    if (professionalOrCenter) {
        return totalTests
    }
    if (companyServices.length != 0) {
        return totalTests.filter(testId => companyServices.some(s => s.id === testId))
    } else {
        return totalTests.filter(testId => !COMPANIES_TESTS.some(item => item === testId) && !ONLY_360_USERS_TESTS.some(item => item === testId)).filter(testId => inMx ? !NOT_IN_MX_TESTS.some(item => item === testId) : true)
    }
}

export function testRoute (testId) {
    switch (true) {
        case testId === 'ryff-scale':
            return '/patient/tests/bienestar-psicologico'
        default:
            return `/patient/tests/${testId}`
    }
}

export function testsToDisplayOnBlocks (companyServices, context, blockName = INDEPENDENT_TESTS) {
    return testToShow(companyServices).filter(testId => blockName.tests.includes(testId)).map((testId) => {
        const test = testId.replace('Test ', '').toLocaleLowerCase().replace(' ', '-')
        return {
            id: `${test}-block`,
            title: context.$t(`tests.${test}.title`),
            action: () => {
                context.$router.push(testRoute(test))
            },
            img: `/static-appopensalud/img/icons/morillas-svg-icons/primary/test-${test}.svg`,
            only360Users: ONLY_360_USERS_TESTS.includes(test)
        }
    })
}


// WEBPACK FOOTER //
// ./src/helpers/tests.helpers.js